<template>
  <div>
    <Heading :level="3" class="instrument-about__title">
      {{ about.title }}
    </Heading>
    <div class="instrument-about__content">
      <div class="instrument-about__item">
        <Row>
          <template #icon-left>
            <img
              v-if="about.image"
              class="instrument-about__logo"
              :src="about.image.medium"
              alt=""
            />
          </template>
          <template #top-left>{{ about.name.value }}</template>
          <template #bottom-left>
            <BaseText :color="textColor">{{ about.name.description }}</BaseText>
          </template>
        </Row>
        <Row>
          <template #top-left>{{ about.document.value }}</template>
          <template #bottom-left>
            <BaseText :color="textColor">
              {{ about.document.description }}
            </BaseText>
          </template>
        </Row>
        <Row v-if="about.administrator">
          <template #top-left>{{ about.administrator.value }}</template>
          <template #bottom-left>
            <BaseText :color="textColor">
              {{ about.administrator.description }}
            </BaseText>
          </template>
        </Row>
      </div>

      <div class="instrument-about__item">
        <Row>
          <template #top-left>{{ about.segment.value }}</template>
          <template #bottom-left>
            <BaseText :color="textColor">
              {{ about.segment.description }}
            </BaseText>
          </template>
        </Row>

        <Row>
          <template #top-left>{{ about.type.value }}</template>
          <template #bottom-left>
            <BaseText :color="textColor">{{ about.type.description }}</BaseText>
          </template>
        </Row>
        <Row v-if="about.managementType">
          <template #top-left>{{ about.managementType.value }}</template>
          <template #bottom-left>
            <BaseText :color="textColor">
              {{ about.managementType.description }}
            </BaseText>
          </template>
        </Row>
      </div>
    </div>

    <p class="instrument-about__content__text">
      {{ about.description }}
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { BaseText, Heading, Row } from '@warrenbrasil/nebraska-web';

import { IInstrumentAbout } from './types';

@Component({
  components: {
    BaseText,
    Heading,
    Row
  }
})
export default class InstrumentAbout extends Vue {
  @Prop({ type: Object, required: true })
  public about!: IInstrumentAbout;

  public NebraskaColors = NebraskaColors;

  public get textColor() {
    return NebraskaColors.textSecondary;
  }
}
</script>

<style lang="less" scoped>
.instrument-about__logo {
  width: 48px;
  height: 48px;
}

.instrument-about__content {
  display: flex;
  justify-content: space-between;
}

.instrument-about__item {
  width: 48%;
  img {
    border-radius: 24px;
  }
}

.instrument-about__content__text {
  padding-top: @size-spacing-x400;
}

.instrument-about__title {
  padding-bottom: @size-spacing-x350;
}
</style>
